import { render } from "./ModalImportTiktok.vue?vue&type=template&id=242f61f2"
import script from "./ModalImportTiktok.vue?vue&type=script&lang=js"
export * from "./ModalImportTiktok.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__